import React, { useEffect, useState } from 'react';
import { Alert, Card, Col, Row } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { useToast } from 'context/providers/ToastProvider';
import useToken from 'hooks/useToken';
import PagosTittle from './PagosTittle';
import PropTypes from 'prop-types';

const PagosTotales = ({ filters }) => {
    const { token } = useToken();
    const { showErrorToast } = useToast();

    const [cargando, setCargando] = useState(true);
    const [subtotalUSD, setSubtotalUSD] = useState(0);
    const [subtotalMXN, setSubtotalMXN] = useState(0);
    const [totalMXN, setTotalMXN] = useState(0);
    const [alertasPagos, setAlertasPagos] = useState({});

    const [show, setShow] = useState(true);
    const [showAlertas, setShowAlertas] = useState(true);

    useEffect(() => {
        if (filters.month && filters.year) {
            ObtenerPagosTotales();
        }
    }, [
        filters.month,
        filters.year,
        filters.idCatCuentaBancaria,
        filters.idCatMedioPago,
        filters.idVendedor,
        filters.filterValidados,
        filters.filterStatus
    ]);

    const ObtenerPagosTotales = async () => {
        setCargando(true);
        const url = `/api/AdministracionPagos/ObtenerPagosTotales/?month=${filters.month}&year=${filters.year}&idCatCuentaBancaria=${filters.idCatCuentaBancaria}&idMedioPago=${filters.idCatMedioPago}&idVendedor=${filters.idVendedor}&iValidado=${filters.filterValidados}&iEstatus=${filters.filterStatus}`;

        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        }).catch((error) => {
            showErrorToast('' + error.message);
        });

        if (response && response.ok) {
            const objResponse = await response.json();
            if (objResponse.iResponseType == 1) {
                const data = JSON.parse(objResponse.detalles);
                setSubtotalUSD(data['table2']?.[0]?.SubtotalUSD || 0);
                setSubtotalMXN(data['table3']?.[0]?.SubtotalMXN || 0);
                setTotalMXN(data['table4']?.[0]?.totalMXN || 0);
                setAlertasPagos(data['table5']?.[0] || {});
            }
        }
        setCargando(false);
    };

    return (
        <>
            <PagosTittle cargando={cargando} />

            <Card className="mb-1">
                <Card.Header>
                    <Row className="justify-content-center">
                        <Col className="col-xxl-4 col-xl-5 col-lg-6 col-md-7 col-sm-12 col-12 align-items-center d-flex mb-2">
                            <div className="d-flex align-items-center">
                                {cargando ? <Skeleton height={50} width={100} /> :
                                    <div>
                                        <h6 className="fs--1 text-600 mb-0 text-nowrap">Subtotal MXN</h6>
                                        <h6 className="fs-0 d-flex align-items-center text-700 mb-1">
                                            {subtotalMXN.toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                        </h6>
                                        <h6 className="fs--2 text-600 mb-0 mt-0">IVA {(subtotalMXN - (subtotalMXN / 1.16)).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}</h6>
                                    </div>
                                }
                                <div className="bg-200 mx-3" style={{ height: '24px', width: '1px' }}></div>
                            </div>
                            <div className="d-flex align-items-center">
                                {cargando ? <Skeleton height={50} width={100} /> :
                                    <div>
                                        <h6 className="fs--1 text-600 mb-0 text-nowrap">Subtotal USD</h6>
                                        <h6 className="fs-0 d-flex align-items-center text-700 mb-1">
                                            {subtotalUSD.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}
                                        </h6>
                                        <h6 className="fs--2 text-600 mb-0 mt-0">IVA {(subtotalUSD - (subtotalUSD / 1.16)).toLocaleString('en-US', { style: 'currency', currency: 'USD' })}</h6>
                                    </div>
                                }
                                <div className="bg-200 mx-3" style={{ height: '24px', width: '1px' }}></div>
                            </div>
                            <div className="d-flex align-items-center">
                                {cargando ? <Skeleton height={50} width={100} /> :
                                    <div>
                                        <h6 className="fs--1 text-600 mb-0 text-nowrap">TOTAL MXN</h6>
                                        <h6 className="fs-0 d-flex align-items-center text-primary mb-1">
                                            {totalMXN.toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}
                                        </h6>
                                        <h6 className="fs--2 text-600 mb-0 mt-0">IVA {(totalMXN - (totalMXN / 1.16)).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}</h6>
                                    </div>
                                }
                                <div className="bg-200 mx-3" style={{ height: '24px', width: '1px' }}></div>
                            </div>
                        </Col>

                        <Col>
                            {show &&
                                <Alert key={"warning"} variant={"warning"} onClose={() => setShow(false)} className="fs--1" dismissible>
                                    🏴 Los <b>totales</b> estan basados en todos los pagos <b>ACTIVOS</b> registrados.
                                    <br />
                                    🏴 Los <b>totales</b> solo son el resultado de los filtros seleccionados.
                                </Alert>
                            }
                        </Col>
                    </Row>

                    <Row>
                        {cargando ? <Skeleton height={150} className="mb-2" /> :
                            <Col className="col-12">
                                {showAlertas && (alertasPagos.numNoValidados > 0 || alertasPagos.numNoFacturados > 0 || alertasPagos.numNoActivos > 0) &&
                                    <Alert key={"warning"} variant={"warning"} onClose={() => setShowAlertas(false)} className="fs--1" dismissible>
                                        Las <b>alertas</b> a continuación, son de <b>acuerdo</b> a los <b>datos</b> devueltos con los <b>filtros configurados</b>.
                                        <br /><br />
                                        {alertasPagos.numNoValidados > 0 &&
                                            <p className="mb-1">
                                                🏴 <b>{alertasPagos.numNoValidados}</b> <strong> {alertasPagos.numNoValidados > 1 ? "pagos" : "pago"}</strong> <span className="text-danger fw-bold">{alertasPagos.numNoValidados > 1 ? "NO validados" : "NO validado"}</span>.
                                            </p>
                                        }
                                        {alertasPagos.numNoFacturados > 0 &&
                                            <p className="mb-1 mt-1">
                                                🏴 <b>{alertasPagos.numNoFacturados}</b> <strong>{alertasPagos.numNoFacturados > 1 ? "pagos" : "pago"}</strong> <span className="text-danger fw-bold">{alertasPagos.numNoFacturados > 1 ? "NO conciliados" : "NO conciliado"}</span>.
                                            </p>
                                        }
                                        {alertasPagos.numNoActivos > 0 &&
                                            <p className="mb-1 mt-1">
                                                🏴 <b>{alertasPagos.numNoActivos}</b> <strong>{alertasPagos.numNoActivos > 1 ? "pagos" : "pago"}</strong> <span className="text-danger fw-bold">{alertasPagos.numNoActivos > 1 ? "Cancelados" : "Cancelado"}</span>.
                                            </p>
                                        }
                                    </Alert>
                                }
                            </Col>
                        }
                    </Row>
                </Card.Header>
            </Card>
        </>
    );
};

PagosTotales.propTypes = {
    filters: PropTypes.object.isRequired
};

export default PagosTotales;
